export default class Locale_UserDetails {
	Cycle: string = "Cycle";
	API: string = "API";
	Function: string = "FUNCTION";
	UI: string = "UI";
	Version: string = "Version";
	UserSettings: string = "User settings";
	SignOut: string = "Sign out";
}